import React, { memo, useState, useEffect } from "react";
import TableMain from "../shared/TableMain";
// import Booking from "./data/Bookings.json";
import { BookingsMain, BookingsSelectDate } from "./styles/BookingStyle";
import { GetDriverActionsByID } from "../../../services/admin/drivers";
// import SelectDate from "../shared/SelectDate";
import { useParams } from "react-router-dom";
import Loader from "../../shared/loader";
import NotFoundIcon from "../../shared/NotFoundIcon";

const Earnings = () => {
  const { id } = useParams();
  const [OrdersData, SetOrdersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [AllData, setAllData] = useState([]);

  useEffect(() => {
    getAllEarnings();
  }, [id]);

  const getAllEarnings = async () => {
    await GetDriverActionsByID(setLoading, setAllData, id, "earnings");
  };

  useEffect(() => {
    if (AllData && AllData?.data?.earnings?.data?.length > 0) {
      const modifiedData = AllData?.data?.earnings?.data?.map((values) => {
        const Sender = values?.stops[0]?.contact_name;
        const order_id = values?.order_id;
        const created_at = values?.created_at;
        const Receiver = values?.stops[1]?.contact_name;

        const Order = values?.stops[0]?.order_detail?.name;
        const Driver = values?.driver_name;
        const Price = values?.price;
        const status = values?.status;
        // const Driver = values?.driver_name;

        // Remove the "stops" array from the object using destructuring
        // const { stops, ...modifiedValues } = values;

        return {
          // ...modifiedValues,
          order_id,
          created_at,
          Sender,
          Receiver,
          Order,
          Driver,
          Price,
          status,
        };
      });

      // Update the OrdersData state with the modified array
      SetOrdersData(modifiedData || []);
    }
  }, [AllData]);

  const TableHeadData = [
    { title: "ID", val: "ID" },
    { title: "Date & Time", val: "DateTime" },
    { title: "Sender", val: "Sender" },
    { title: "Receiver", val: "Receiver" },
    { title: "Order", val: "Order" },
    { title: "Customer Price", val: "CustomerPrice" },
    { title: "Driver Price", val: "DriverPrice" },
    { title: "Status", val: "status" },
  ];
  return (
    <>
      {loading && <Loader />}
      <BookingsMain>
        {/* <BookingsSelectDate>
          <SelectDate />
        </BookingsSelectDate> */}

        {AllData && AllData?.message === "Success" && OrdersData?.length > 0 ? (
          <TableMain
            TableHeadData={TableHeadData}
            BodyData={OrdersData}
            Hasaction={false}
            TableType="drivers/booking"
          />
        ) : (
          !loading && <NotFoundIcon MT="20" IconWidth="10" />
        )}
      </BookingsMain>
    </>
  );
};

export default memo(Earnings);
